module.exports = __webpack_public_path__ + "static/media/alarm-3.13f976ca.svg";